import { render, staticRenderFns } from "./LargeNavbarElement.vue?vue&type=template&id=1273668f&scoped=true"
import script from "./LargeNavbarElement.vue?vue&type=script&lang=js"
export * from "./LargeNavbarElement.vue?vue&type=script&lang=js"
import style0 from "./LargeNavbarElement.vue?vue&type=style&index=0&id=1273668f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1273668f",
  null
  
)

export default component.exports